import { Map } from 'immutable';

import * as PlaybackConstants from './constants';
import * as D from './deps';

export const INITIAL_STATE = Map({
  [PlaybackConstants.PlaybackKeys.HAS_PLAYBACK_STARTED_IN_SESSION]: false,
  [PlaybackConstants.PlaybackKeys.SHOULD_AUTO_START]: false,
  [PlaybackConstants.PlaybackKeys.SOURCE_STARTING]: false,
});

export default D.createReducer(INITIAL_STATE, {
  [PlaybackConstants.ActionKeys.SET_AUTO_START_ENABLED]: onSetAutoStartEnabled,
  [D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK]: onTrackStarted,
  [D.Constants.Integrations.ActionTypes.STARTING_SOURCE]: onStartingSource,
  [D.Constants.Integrations.ActionTypes.SOURCE_STARTED]: resetSourceStarting,
  [D.Constants.Integrations.ActionTypes.START_SOURCE_INCOMPLETE]: resetSourceStarting,
  [PlaybackConstants.ActionKeys.RESET_PLAYBACK_STARTED]: resetPlaybackStarted,
});

function onSetAutoStartEnabled(state, { data }) {
  return state.set(PlaybackConstants.PlaybackKeys.SHOULD_AUTO_START, data.shouldEnable);
}

function onStartingSource(state) {
  return state.set(PlaybackConstants.PlaybackKeys.SOURCE_STARTING, true);
}

function onTrackStarted(state) {
  return state.set(PlaybackConstants.PlaybackKeys.HAS_PLAYBACK_STARTED_IN_SESSION, true);
}

function resetSourceStarting(state) {
  return state.set(PlaybackConstants.PlaybackKeys.SOURCE_STARTING, false);
}

function resetPlaybackStarted(state) {
  return state.set(PlaybackConstants.PlaybackKeys.HAS_PLAYBACK_STARTED_IN_SESSION, false);
}
